import { FC, PropsWithChildren } from "react";
import { useResponsive } from "capitalrx-components-2.0/lib/layout";
import styled from "styled-components";

const _PageWrapper = styled.div<{ readonly $iscompressed?: string }>`
  padding-top: 64px;
  padding-bottom: 64px;
  margin-bottom: auto;

  background-size: 100% 200px;
  background-repeat: space no-repeat;

  padding-left: ${({ $iscompressed }) => ($iscompressed === "true" ? "16px" : "8.3333%")};
  padding-right: ${({ $iscompressed }) => ($iscompressed === "true" ? "16px" : "8.3333%")};
`;

export const PageWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { isCompressed } = useResponsive({
    isCompressed: {
      mobile: true,
      desktop: false,
    },
  });

  return (
    <_PageWrapper $iscompressed={isCompressed.toString()}>
      <>{children}</>
    </_PageWrapper>
  );
};
